import { Component } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Subscription } from 'rxjs';
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import {AirManagementService}  from 'src/app/services/air-management.service'
import { Observable } from 'rxjs/internal/Observable';
import { City, Country, State, StaticdataService } from 'src/app/services/staticdata.service';
import { CustomValidatorsService } from 'src/app/services/custom-validators.service';
import { map } from 'rxjs/internal/operators/map';
import { startWith } from 'rxjs/internal/operators/startWith';
import { DataService } from 'src/app/services/data.service';
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';

@Component({
  selector: 'app-manual-cart',
  templateUrl: './manual-cart.component.html',
  styleUrls: ['./manual-cart.component.css']
})
export class ManualCartComponent {

  showPnrRetrieval:boolean=false
  showGeneratePNR:boolean=false
  showHotelCart:boolean=false
  pnrRegFg!:FormGroup



 
  id:any
  constructor( private data:DataService, private route :ActivatedRoute,private staticDataService : StaticdataService,private customValidator : CustomValidatorsService,private SettingsService:SettingsService,private router:Router,private location:Location,private fb : FormBuilder,    private toastMsgService : ToastmsgService,
    private PaymentConfigService:PaymentConfigService,private AirManagementService:AirManagementService,private userPrivileges: UserPrivilegeService,
    ){
      this.userPrivileges.userPrivilegesByModule('Manual-Cart').then((privileges:any) => {
        this.privilegesValue(privileges)
      })
      .catch((error:any) => {
      console.error(error); // Handle errors, if any
      });
  //  this.route.queryParams.subscribe(params => {
  //   let data:any
  //   data=params
  //   this.id=this.decodeTransformedcode(data.id)
   
  //  // for(let i=0 ;i <data.length; i++){ this.email +=data[i]; }
    
    
  
  //     });
   this.onClickRetrieval()
    }
    privilegesView:any
  privilegesValue(privs:any){
    let privileges="";
  if(privs.includes('view')){
    this.privilegesView="VAMD"
  }else{
    this.privilegesView="AccessDenied"
  }

  }
    ngOnInit(): void  {
      
    }
    decodeTransformedcode(encodedEmail: string): string {
      let result = '';
    
      for (let i = 0; i < encodedEmail.length; i += 2) {
        const hexChar = encodedEmail.slice(i, i + 2);
        const charCode = parseInt(hexChar, 16); // Convert the hexadecimal string to a character code
        result += String.fromCharCode(charCode);
      }
    
      return result;
    }
  dataFields(){
    this.pnrRegFg=this.fb.group({
     
    });
  }
  
  

  backClick(){
   // window.location.href="/app/settings"
   window.location.href='/app/flight'

      } 
   

    onClickRetrieval(){
this.showPnrRetrieval=true
this.showGeneratePNR=false
this.showHotelCart=false

    }
    onClickGeneratePNR(){
      this.showPnrRetrieval=false
      this.showHotelCart=false
      this.showGeneratePNR=true
          }

          onClickHotel(){
            this.showPnrRetrieval=false
      this.showGeneratePNR=false
      this.showHotelCart=true
          }

          isActive(route: string): boolean {
            return this.router.isActive(route, true);
          }
         
}
